var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-expansion-panels",
    {
      attrs: { flat: "", accordion: "", multiple: "" },
      model: {
        value: _vm.panel,
        callback: function($$v) {
          _vm.panel = $$v
        },
        expression: "panel"
      }
    },
    [
      _c(
        "display-expansion-panel",
        [
          _c(
            "display-expansion-panel-header",
            { staticClass: "text-uppercase info--text" },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.generateMessage(
                      "properties_360.titles.contractual_commitment"
                    )
                  ) +
                  "\n    "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "v-expansion-panel-content",
            [
              _c("display-checkbox", {
                staticClass: "px-2",
                attrs: {
                  label: _vm.generateMessage(
                    "properties_360.fields.energy_management.fictitious_enabled"
                  ),
                  "input-value":
                    _vm.property.energy_management.fictitious_enabled
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex" }, [
                _c(
                  "div",
                  { staticClass: "mx-2", staticStyle: { width: "50%" } },
                  [
                    _c(
                      "v-simple-table",
                      {
                        staticClass: "my-2 background no-hover",
                        attrs: { dense: "" }
                      },
                      [
                        _c("tbody", [
                          _c("tr", [
                            _c(
                              "td",
                              {
                                staticClass:
                                  "caption px-2 py-0 font-weight-bold"
                              },
                              [
                                _vm._v(
                                  "\n                  Type de marché\n                "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticClass: "caption px-2 py-0 text-end" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "caption pa-0 font-weight-bold"
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(_vm.property.market_type) +
                                        "\n                  "
                                    )
                                  ]
                                )
                              ]
                            )
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "d-flex" },
                      [
                        _c("custom-simple-table", {
                          staticClass: "px-2",
                          staticStyle: { width: "50%" },
                          attrs: {
                            item: _vm.property.energetic_efficiency,
                            "i18-path":
                              "properties_360.fields.energetic_efficiency",
                            "table-keys": ["heating_period"]
                          }
                        }),
                        _vm._v(" "),
                        _c("custom-simple-table", {
                          staticClass: "px-2",
                          staticStyle: { width: "50%" },
                          attrs: {
                            item: _vm.property.energy_management,
                            "i18-path":
                              "properties_360.fields.energy_management",
                            "table-keys": ["maintenance_shutdown_period"]
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-simple-table",
                      {
                        staticClass: "background my-2 no-hover",
                        attrs: { dense: "" }
                      },
                      [
                        _c("tbody", [
                          _c("tr", [
                            _c(
                              "td",
                              {
                                staticClass:
                                  "caption px-2 py-0 font-weight-bold"
                              },
                              [
                                _vm._v(
                                  "\n                  Fréquence de relève\n                "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticClass: "caption px-2 py-0 text-end" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "caption pa-0 font-weight-bold"
                                  },
                                  [
                                    _vm._v(
                                      "\n                    en chauffe\n                  "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "caption pa-0 text-end" },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.property.energetic_efficiency
                                            .frequency_with_heating
                                        ) +
                                        "\n                  "
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticClass: "caption px-2 py-0 text-end" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "caption pa-0 font-weight-bold"
                                  },
                                  [
                                    _vm._v(
                                      "\n                    hors chauffe\n                  "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "caption pa-0 text-end" },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.property.energetic_efficiency
                                            .frequency_without_heating
                                        ) +
                                        "\n                  "
                                    )
                                  ]
                                )
                              ]
                            )
                          ])
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "mx-2", staticStyle: { width: "50%" } },
                  [
                    _c(
                      "div",
                      { staticClass: "caption font-weight-bold pt-2" },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.generateMessage(
                                "properties_360.titles.temperature"
                              )
                            ) +
                            " :\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "d-flex" },
                      [
                        _c(
                          "div",
                          { staticClass: "caption font-weight-bold pt-2" },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.generateMessage(
                                    "properties_360.fields.hot_water"
                                  )
                                ) +
                                " :\n            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("custom-simple-table", {
                          staticClass: "px-2 ml-8",
                          attrs: {
                            item: _vm.property.energetic_efficiency,
                            "i18-path":
                              "properties_360.fields.energetic_efficiency",
                            "table-units": "temperature",
                            "table-keys": [
                              "dhw_temperature_prod",
                              "dhw_temperature_tapwater"
                            ]
                          }
                        }),
                        _vm._v(" "),
                        _c("custom-simple-table", {
                          staticClass: "px-2 ml-8",
                          attrs: {
                            item: _vm.property.energetic_efficiency,
                            "i18-path":
                              "properties_360.fields.energetic_efficiency",
                            "table-units": "temperature",
                            "table-keys": [
                              "dhw_temperature_prod_min",
                              "dhw_temperature_tapwater_min"
                            ]
                          }
                        }),
                        _vm._v(" "),
                        _c("custom-simple-table", {
                          staticClass: "px-2 ml-8",
                          attrs: {
                            item: _vm.property.energetic_efficiency,
                            "i18-path":
                              "properties_360.fields.energetic_efficiency",
                            "table-units": "temperature",
                            "table-keys": [
                              "dhw_temperature_prod_max",
                              "dhw_temperature_tapwater_max"
                            ]
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "d-flex" },
                      [
                        _c(
                          "div",
                          { staticClass: "caption font-weight-bold pt-2" },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.generateMessage(
                                    "properties_360.fields.inside"
                                  )
                                ) +
                                " :\n            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("custom-simple-table", {
                          staticClass: "px-2 ml-8",
                          attrs: {
                            item: _vm.property.energetic_efficiency,
                            "i18-path":
                              "properties_360.fields.energetic_efficiency",
                            "table-units": "temperature",
                            "table-keys": [
                              "temperature_interior",
                              "temperature_ac"
                            ]
                          }
                        }),
                        _vm._v(" "),
                        _c("custom-simple-table", {
                          staticClass: "px-2 ml-8",
                          attrs: {
                            item: _vm.property.energetic_efficiency,
                            "i18-path":
                              "properties_360.fields.energetic_efficiency",
                            "table-units": "temperature",
                            "table-keys": [
                              "temperature_interior_min",
                              "temperature_ac_min"
                            ]
                          }
                        }),
                        _vm._v(" "),
                        _c("custom-simple-table", {
                          staticClass: "px-2 ml-8",
                          attrs: {
                            item: _vm.property.energetic_efficiency,
                            "i18-path":
                              "properties_360.fields.energetic_efficiency",
                            "table-units": "temperature",
                            "table-keys": [
                              "temperature_interior_max",
                              "temperature_ac_max"
                            ]
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("custom-simple-table", {
                      staticClass: "pt-2",
                      staticStyle: { "max-width": "250px" },
                      attrs: {
                        item: _vm.property,
                        "i18-path":
                          "properties_360.fields.energetic_efficiency",
                        "table-keys": ["reduced_temperature"]
                      }
                    })
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "display-expansion-panel",
        [
          _c(
            "display-expansion-panel-header",
            { staticClass: "text-uppercase info--text" },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.generateMessage("properties_360.titles.property")
                  ) +
                  "\n    "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "v-expansion-panel-content",
            [
              _c("display-checkbox", {
                staticClass: "py-5",
                attrs: {
                  label: _vm.generateMessage(
                    "properties_360.fields.energy_management.command_authorized"
                  ),
                  "input-value":
                    _vm.property.energy_management.command_authorized
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex" }, [
                _c(
                  "div",
                  { staticClass: "px-3", staticStyle: { width: "50%" } },
                  [
                    _c("custom-simple-table", {
                      attrs: {
                        item: _vm.propertyDetails,
                        "i18-path": "properties_360.fields",
                        "table-keys": [
                          "technician_affected",
                          "fees_prestation_name",
                          "autonomy",
                          "observation",
                          "altitude",
                          "geographical_area"
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "caption font-weight-bold" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.generateMessage(
                              "properties_360.fields.energy_management.stations.name"
                            )
                          ) +
                          "\n            :\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _vm.stations.length
                      ? _c("span", { staticClass: "caption" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.stations[0].name) +
                              " : " +
                              _vm._s(_vm.stations[0].temperature) +
                              "°C\n          "
                          )
                        ])
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "px-3", staticStyle: { width: "50%" } },
                  [
                    _c("custom-simple-table", {
                      attrs: {
                        item: _vm.propertyDetails,
                        "i18-path": "properties_360.fields",
                        "table-keys": [
                          "heating_program",
                          "fuel_type",
                          "fluid_coolant",
                          "power_hot",
                          "cold_power",
                          "power_unit"
                        ]
                      }
                    })
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }